// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "3a455d34",
    "hash": "3a455d34",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3a455d34",
    "semverString": null,
    "version": "1.0.17"
};
/* tslint:enable */
